import {
  defaultBorders,
  defaultGapping,
  defaultLayouts,
  defaultPadding,
  defaultTypography,
  golfstatusColors,
  GSInfoGroup,
} from "golfstatus_react_components";
import { faExclamationCircle, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TournamentMessageConfirmationTournamentItem = (props) => {
  const { tournament, groupNames = [], messageType = "message" } = props;

  const uniqueRecipientCount = tournament?.uniqueRecipientCount ?? 0;
  const unavailableCount = tournament?.unavailableCount ?? 0;
  const selectedRecipientCount = tournament?.selectedRecipientCount ?? 0;
  const showUnavailable = unavailableCount > 0;

  const unavailableText =
    messageType === "email"
      ? "Recipients must have a valid email address"
      : "Recipients must have a valid email address and download the GolfStatus app";

  return (
    <tournament-message-confirmation-tournament-item style={{ display: "block", width: "100%" }}>
      <div
        style={{
          ...defaultLayouts.vStack,
          ...defaultLayouts.fullWidth,
          ...defaultPadding.xLargePad,
          ...defaultGapping.mediumLargeGap,
          ...defaultBorders.mediumLargeBorderRadius,
          backgroundColor: golfstatusColors.grey50,
          boxSizing: "border-box",
        }}
      >
        <div style={{ ...defaultLayouts.vStack, ...defaultLayouts.fullWidth, ...defaultGapping.mediumGap }}>
          <div
            style={{
              ...defaultLayouts.hStack.align("unset", "center"),
              ...defaultGapping.mediumGap,
              ...defaultTypography.headline2,
              color: golfstatusColors.cyan700,
            }}
          >
            <FontAwesomeIcon icon={faUsers} />
            <span>{uniqueRecipientCount}</span>
          </div>
          <GSInfoGroup
            dataGroups={[
              {
                fit: "stretch",
                sections: [
                  {
                    sectionItems: [
                      {
                        type: "primary full-width",
                        sectionItemStyle: { whiteSpace: "normal" },
                        value: tournament?.name ?? "Tournament",
                      },
                      ...(groupNames.length > 0
                        ? [
                            {
                              type: "secondary full-width",
                              sectionItemStyle: { whiteSpace: "normal" },
                              value: groupNames.join(" / "),
                            },
                          ]
                        : []),
                    ],
                  },
                ],
              },
            ]}
          />
        </div>

        {showUnavailable && (
          <div
            style={{
              ...defaultLayouts.hStack.align("unset", "center"),
              ...defaultLayouts.fullWidth,
              ...defaultGapping.largeGap,
              ...defaultPadding.largePad,
              ...defaultBorders.mediumLargeBorderRadius,
              backgroundColor: golfstatusColors.white,
              boxSizing: "border-box",
              whiteSpace: "normal",
            }}
          >
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ color: golfstatusColors.orange400 }}
            />
            <GSInfoGroup
              dataGroups={[
                {
                  fit: "stretch",
                  sections: [
                    {
                      sectionItems: [
                        {
                          type: "primary full-width",
                          sectionItemStyle: { whiteSpace: "normal" },
                          value: `${unavailableCount} of ${selectedRecipientCount} selected recipients won't receive this ${messageType}`,
                        },
                        {
                          type: "secondary full-width",
                          sectionItemStyle: { whiteSpace: "normal" },
                          value: unavailableText,
                        },
                      ],
                    },
                  ],
                },
              ]}
            />
          </div>
        )}
      </div>
    </tournament-message-confirmation-tournament-item>
  );
};

export default TournamentMessageConfirmationTournamentItem;
